
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("99rcJ", function(module, exports) {

$parcel$export(module.exports, "CalendarsLink", () => $544e89ef74bbdb03$export$5bc2ad8fe7e5e700);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $3gadb = parcelRequire("3gadb");

var $8DN9t = parcelRequire("8DN9t");

var $7x0As = parcelRequire("7x0As");

var $1NBp8 = parcelRequire("1NBp8");

var $luv00 = parcelRequire("luv00");

var $61vzn = parcelRequire("61vzn");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $1ytiN = parcelRequire("1ytiN");

var $dPJCf = parcelRequire("dPJCf");
const $544e89ef74bbdb03$export$5bc2ad8fe7e5e700 = (props)=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    /**
   * showTCNav:
   * - Premium -> true, TC is a premium feature
   * - Standard -> true, iff user is Org/Site Admin, otherwise, false (https://hello.atlassian.net/wiki/spaces/CE2/pages/3031965072/ETC+Standard+P18N+Technical+Spec)
   * - Free -> true, TC upsell to all Free users (https://hello.atlassian.net/wiki/spaces/CE2/pages/2906634153/ETC+P18N+Technical+Spec)
   */ const showTCNav = edition === (0, $euL71.ConfluenceEdition).STANDARD ? isSiteAdmin : true;
    return showTCNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($544e89ef74bbdb03$var$CalendarsLinkInner, props) : null;
};
const $544e89ef74bbdb03$var$CalendarsLinkInner = ({ onClick: onClick })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSelected = (0, $dPJCf.useRouteName)($544e89ef74bbdb03$var$isOnSCalendarsRoute);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $544e89ef74bbdb03$var$i18n.calendarsTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7x0As.MenuLinkItem), {
        href: (0, $1NBp8.SPACE_CALENDARS).toUrl({
            spaceKey: spaceKey
        }),
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
            label: "",
            color: "currentColor"
        }),
        isSelected: isSelected,
        "data-vc": "team-calendar-navigation",
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $61vzn.ReverseTrialLozengeListItemExperiment), {
            touchpointId: "confluence_reverse_trial_lozenges_tc_space_navigation",
            edition: (0, $euL71.ConfluenceEdition).PREMIUM
        }),
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $544e89ef74bbdb03$var$i18n.calendars), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $61vzn.PremiumLozengeLoadable), null)));
};
const $544e89ef74bbdb03$var$isOnSCalendarsRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_CALENDARS).name || routeName === (0, $1NBp8.SPACE_CALENDARS_SUBCALENDAR).name
};
const $544e89ef74bbdb03$var$i18n = (0, $2nPZH.defineMessages)({
    calendarsTooltip: {
        id: "side-navigation.space-navigation.calendars.tooltip",
        defaultMessage: "View calendar"
    },
    calendars: {
        id: "side-navigation.space-navigation.calendars",
        defaultMessage: "Calendars"
    }
});

});
parcelRegister("8DN9t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $019f9d4947dadb8d$var$_react = $019f9d4947dadb8d$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $019f9d4947dadb8d$var$_baseNew = $019f9d4947dadb8d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $019f9d4947dadb8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $019f9d4947dadb8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $019f9d4947dadb8d$var$_react.default.createElement($019f9d4947dadb8d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$019f9d4947dadb8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $019f9d4947dadb8d$var$_default = module.exports.default = $019f9d4947dadb8d$var$CalendarIcon;

});

parcelRegister("61vzn", function(module, exports) {

$parcel$export(module.exports, "TrialFlags", () => $5e8e088fe72e4df1$export$c108f21945b8b79);
$parcel$export(module.exports, "PremiumLozengeLoadable", () => $5e8e088fe72e4df1$export$62673719cbe80cd0);
$parcel$export(module.exports, "ReverseTrialLozengeExperiment", () => $5e8e088fe72e4df1$export$b51195909514673e);
$parcel$export(module.exports, "ReverseTrialLozengeListItemExperiment", () => $5e8e088fe72e4df1$export$e82a504f7cb45e99);
$parcel$export(module.exports, "PremiumLozengeImage", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("leRtl")))));

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

var $leRtl = parcelRequire("leRtl");

const $5e8e088fe72e4df1$var$TrialFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pBDfE",
    name: "TrialFlagsLoadable",
    loader: async ()=>(await (parcelRequire("hfSv4"))).TrialFlags
});
const $5e8e088fe72e4df1$export$c108f21945b8b79 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).GROWTH_LUNA
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5e8e088fe72e4df1$var$TrialFlagsLoadable, null));

const $5e8e088fe72e4df1$export$62673719cbe80cd0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Txnkb",
    name: "PremiumLozengeLoadable",
    loader: async ()=>(await (parcelRequire("lhVPO"))).PremiumLozenge
});

const $5e8e088fe72e4df1$export$b51195909514673e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EHgbD",
    name: "ReverseTrialLozengeExperiment",
    loader: async ()=>(await (parcelRequire("eGXb5"))).ReverseTrialLozengeWithErrorBoundary
});

const $5e8e088fe72e4df1$export$e82a504f7cb45e99 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DLH6o",
    name: "ReverseTrialLozengeListItemExperiment",
    loader: async ()=>(await (parcelRequire("k6SWH"))).ReverseTrialListItemWithErrorBoundary
});

});
parcelRegister("leRtl", function(module, exports) {
module.exports = new URL("premiumLozenge.aa9b0435.svg", import.meta.url).toString();

});

parcelRegister("hfSv4", function(module, exports) {

let $c8fe1cfbeff454a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c8fe1cfbeff454a9$var$load("cmcKh"),
    $c8fe1cfbeff454a9$var$load("ktyyJ")
]).then(()=>parcelRequire('1VYG6'));

});

parcelRegister("lhVPO", function(module, exports) {

let $f7f80c459b873240$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7f80c459b873240$var$load("4yUSc").then(()=>parcelRequire('9xi4O'));

});

parcelRegister("eGXb5", function(module, exports) {

let $ab22e47061ac33b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ab22e47061ac33b9$var$load("2uoBF"),
    $ab22e47061ac33b9$var$load("fqBFU")
]).then(()=>parcelRequire('gQsLh'));

});

parcelRegister("k6SWH", function(module, exports) {

let $ea3efd42a3c56b52$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ea3efd42a3c56b52$var$load("2uoBF"),
    $ea3efd42a3c56b52$var$load("fqBFU"),
    $ea3efd42a3c56b52$var$load("1HAEl")
]).then(()=>parcelRequire('f3FIN'));

});




//# sourceMappingURL=CalendarsLink.45fb6f3f.js.map
